import React, { useContext } from 'react';
import { FormattedMessage } from 'react-intl';

import TradeDetails from '../../../../../../_shared/models/TradeDetails';

import SendToClosingContainer from '../../../../../ModalButton/NegotiationButton/SendToClosingContainer';
import BidBoxContext from '../../../../BidBoxContainer/BidBoxContext';
import PendingBidBoxFooterContext from '../../PendingBidBoxFooterContainer/PendingBidBoxFooterContext';

import { OmpSendToClosingButton, StyledSecondaryButton } from './Styles';

const BidBoxSendToClosingButton = ({ isOmp = false }) => {
  const { tradeDetails } = useContext(BidBoxContext);
  const { negotiationState } = useContext(PendingBidBoxFooterContext);

  const trade = TradeDetails.asPendingTrade(tradeDetails, negotiationState);

  const getSendToClosingButton = onClick => {
    const message = (
      <FormattedMessage id="vdp.pending.seller.button.sendToClosing" />
    );
    const StyledButton = isOmp ? OmpSendToClosingButton : StyledSecondaryButton;
    return <StyledButton onClick={onClick}>{message}</StyledButton>;
  };
  return (
    <SendToClosingContainer
      trade={trade}
      topBid={tradeDetails?.auctionSummary?.maxBid}
      associatedTrade={tradeDetails?.associatedTrade}
      Button={({ onClick }) => getSendToClosingButton(onClick)}
    />
  );
};

export default BidBoxSendToClosingButton;
